module.exports = __webpack_public_path__ + "img/customers_v1_cover.9963003.jpg";